import React from 'react';

import { ButtonBase } from '@material-ui/core';

import useTourTooltipStyles from 'components/GuidedTour/useTourTooltipStyles';

const ExtraTouchOnboardingTooltip = ({
  closeProps,
  step,
}) => {
  const classes = useTourTooltipStyles();
  const handleComplete = () => {
    step.data?.onComplete?.();
    closeProps.onClick?.({
      preventDefault: () => {},
      stopPropagation: () => {},
    });
  };

  const handleAddOneNow = () => {
    handleComplete();
    window.setTimeout(() => {
      step.data?.onAddOneNow?.();
    }, 0);
  };

  const handleDismiss = (event) => {
    step.data?.onDismiss?.();
    closeProps.onClick?.(event);
  };

  return (
    <div className={classes.tooltip}>
      <h4 className={classes.title}>Add extra touches here</h4>
      <p className={classes.body}>Use this to add a one-off touch to this campaign.</p>
      <div className={classes.actions}>
        <ButtonBase onClick={handleComplete} className={classes.secondaryAction}>
          Got It
        </ButtonBase>
        <ButtonBase onClick={handleAddOneNow} className={classes.primaryAction}>
          Add One Now
        </ButtonBase>
      </div>
      <ButtonBase
        onClick={handleDismiss}
        aria-label="Close"
        className={classes.closeButton}
      >
        ×
      </ButtonBase>
    </div>
  );
};

export default ExtraTouchOnboardingTooltip;
